<!--
 * @Description: 发票邮寄
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseForm ref="formRef" label-position="top" disabled :model="formData">
    <div class="form-dialog__title">
      <h1>邮寄地址</h1>
    </div>
    <div class="form-dialog__content">
      <BaseFormItem label="收件人" prop="receiptFullName">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          :modelValue="formData.receiptFullName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="联系电话" prop="receiptPhone">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          :modelValue="formData.receiptPhone"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="邮寄地址" prop="receiptAddress">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          :modelValue="formData.receiptAddress"
        ></BaseInput>
      </BaseFormItem>
    </div>
  </BaseForm>
</template>

<script lang="tsx" setup>
import { defineModel } from 'vue';
import { BaseForm, BaseFormItem, BaseInput } from 'xrk-components';
import { IndustryDetailData } from '@V/invoice/src/data-source/types';

const formData = defineModel<IndustryDetailData>();
</script>
